import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { charmGray } from '../../../../web/styles/colors';
import { FontFamilies } from '../../../../web/styles/styles';
import { background, brandPrimary, white } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	floatingPanel: {
		background,
		borderRadius: THEME.common.borderRadius,
		padding: THEME.spacing.sm,
		zIndex: 9,
		boxShadow: '0px 0px 16px rgba(139, 139, 139, 1)',
		width: 420,
	},
	root: {
		backgroundColor: white,
		borderRadius: THEME.common.borderRadius,
		boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
		display: 'flex',
		flexDirection: 'column',
		width: 400,
		maxHeight: 600,
		minHeight: 400,
	},
	header: {
		alignItems: 'center',
		backgroundColor: background,
		borderTopLeftRadius: 6,
		borderTopRightRadius: 6,
		display: 'flex',
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
		justifyContent: 'space-between',
	},
	oneHalf: {
		textAlign: 'center',
		flex: 1,
	},
	iconGroup: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
	},
	iconButton: {
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		fontSize: '18px',
		color: charmGray,
		padding: THEME.spacing.xs,
		':hover': {
			color: brandPrimary,
		},
	},
	realtimeTranscriptionUtterances: {
		backgroundColor: white,
		borderBottomLeftRadius: 6,
		borderBottomRightRadius: 6,
		color: charmGray,
		fontFamily: FontFamilies.regular,
		fontSize: 12,
		height: '100%',
		lineHeight: '14px',
		maxHeight: 500,
		minHeight: 300,
		overflow: 'auto',
		padding: THEME.spacing.md,
		whiteSpace: 'pre-wrap',
		wordWrap: 'break-word',
	},
	aiCallButtonText: {
		display: 'flex',
		alignItems: 'center',
	},
	smallIcon: {
		color: brandPrimary,
		width: 14,
		height: 14,
		marginRight: THEME.spacing.xs,
	},
	modalContainer: {
		padding: THEME.spacing.lg,
		maxWidth: 800,
	},
	modalHeader: {
		display: 'flex',
		alignItems: 'center',
		marginBottom: THEME.spacing.md,
	},
	modalIcon: {
		color: brandPrimary,
		width: 20,
		height: 20,
		marginRight: THEME.spacing.sm,
	},
	modalTitle: {
		margin: 0,
		fontSize: 18,
		fontWeight: 600,
	},
	modalContent: {
		lineHeight: '1.5',
		color: '#333',
		whiteSpace: 'pre-wrap',
		maxHeight: 600,
		overflowY: 'auto',
	},
	loadingContainer: {
		textAlign: 'center',
		padding: 40,
	},
	loadingText: {
		marginTop: THEME.spacing.md,
		color: '#666',
	},
	loadingContainerWithColor: {
		textAlign: 'center',
		padding: 40,
		color: '#666',
	},
});
